export default (s: string, char: string) =>
  s.endsWith(char) ? s.slice(0, -1) : s;
